<template>
  <div id="pbn-filters">
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <input placeholder="URL" type="text" v-model="filters['url']" name="url" id="id-url" ref="url" class="col-lg-8 form-control" @keydown.enter="search">
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin || user.clients.length > 1 || user.roles.length > 1">
        <v-select
            placeholder="Client"
            v-if="this.f.clients && this.f.clients.length"
            :options="f.clients"
           label="name"
            multiple="multiple"
            v-model="multiFilters['clients']"
            :reduce="client => client.id"
            @change="search">
        </v-select>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin">
          <div>
            <v-select placeholder="Group" multiple :options="this.f.groups" v-model="multiFilters['groups']" :reduce="group => group.id" label="fullName" @change="search"></v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select placeholder="Order" :options="this.f.orders" multiple="multiple" @change="search" label="fullName" v-model="multiFilters['orders']">
            </v-select>
          </div>
        </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select placeholder="Status" multiple :options="statuses" v-model="multiFilters['status']" @change="search" >
            </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select  placeholder="Type" multiple :options="types" v-model="multiFilters['type']" @change="search" >
            </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <v-select placeholder="Category" multiple :options="this.f.categories" v-model="filters['categories']" @change="search" >
            </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
        </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin">
          <div>
            <v-select placeholder="Registrar" multiple :options="this.f.registrars" v-model="multiFilters['registrars']" :reduce="registrar => registrar.id" label="name" @change="search"></v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin || user.client === null">
          <div>
            <v-select placeholder="Hosting" multiple :options="f.hosts" v-model="filters['hosting']" index="id" label="name" @change="search" >
            </v-select>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm" v-if="user.admin || user.client === null">
          <div>
            <v-select placeholder="Hosting Type" :options="[{index: 'CUSTOM_HOST', label: 'Digital Ocean'}, {index: 'SHARED_HOSTING', label: 'Priority Prospect'}]" v-model="filters['hostingType']" index="index"  @change="search" >
            </v-select>
         </div>
        </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Language" multiple :options="languages" label="label" index="index" v-model="filters['language']" @change="search" id="iLang"></v-select>
        </div>
      </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="display-flex">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Posts:</div>
              <input type="number" v-model="stats['postsFrom']" min="0" name="" id="iPostsFrom" placeholder="from" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" ref="postsFrom" @keydown.enter="search">
              <input type="number" v-model="stats['postsTo']" min="0" name="" id="iPostsTo" placeholder="to" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" ref="postsTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="display-flex">
              <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input side-input-text">Last Post:</div>
              <input type="date" v-model="filters['lastPostAfter']" min="0" name="" placeholder="after" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
              <input type="date" v-model="filters['lastPostBefore']" min="0" name="" placeholder="before" class="col-lg-4 col-md-4 col-sm-4 col-xs-4 pretty-input " @keydown.enter="search">
            </div>
          </div>
        </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select
            placeholder="Links to"
            multiple
            :options="['No Own Links', 'No Money Links'].concat(this.f.linkTags)"
            v-model="filters['linkTags']"
            @change="search"
          >
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Issues" multiple :options="this.issues" v-model="filters['issues']" index="value" @change="search" >
          </v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Limit" :options="[250,1000,2500]" v-model="filters['limit']" @change="search" >
          </v-select>
        </div>
      </div>
    </div>
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Indexed" :options="quantumCheckbox" label="label" index="value" v-model="filters['indexed']" @change="search"></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Home Indexed" :options="quantumCheckbox" label="label" index="value" v-model="filters['homeIndexed']" @change="search"></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div class="display-flex">
          <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-md hidden-lg">
            Index Count
          </div>
          <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-sm hidden-xs text-tooltip" v-tooltip="'Indexed Pages Count'">
            Count
          </div>
          <input type="number" v-model.number="filters['indexedCountFrom']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
          <input type="number" v-model.number="filters['indexedCountTo']" min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
          <div class="display-flex">
            <div class="col-lg-6 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-md hidden-lg">
              Index To Posts
            </div>
            <div class="col-lg-6 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-sm hidden-xs text-tooltip" v-tooltip="'Index to Posts Ratio'">
              Index / Posts
            </div>
            <input type="number" v-model.number="filters['indexToPostsFrom']"  min="0" name="" placeholder="from" class="col-lg-3 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
            <input type="number" v-model.number="filters['indexToPostsTo']" min="0" name="" placeholder="to" class="col-lg-3 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
          </div>
      </div>
    </div>
    <!-- indexed 200 to group not -->
    <div class="search col-lg-12 col-md-12">
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div class="display-flex">
          <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-md hidden-lg">
            Indexed 200
          </div>
          <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-sm hidden-xs text-tooltip" v-tooltip="'Indexed with status 200'">
            200
          </div>
          <input type="number" v-model.number="filters['indexed200From']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
          <input type="number" v-model.number="filters['indexed200To']" min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div class="display-flex">
          <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-md hidden-lg">
            Indexed 404
          </div>
          <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text hidden-sm hidden-xs text-tooltip" v-tooltip="'Indexed with status 404'">
            404
          </div>
          <input type="number" v-model.number="filters['indexed404From']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
          <input type="number" v-model.number="filters['indexed404To']" min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="WP Theme" :options="['no-theme'].concat(f.themes)" v-model="filters['theme']" multiple @input="search"></v-select>
        </div>
      </div>
      <div class="col-lg-3 col-md-3 m-t-sm">
        <div>
          <v-select placeholder="Group not" multiple :options="this.f.groups" v-model="multiFilters['groupsNot']" :reduce="group => group.id" label="fullName" @change="search"></v-select>
        </div>
      </div>
    </div>
    <!-- stats filter -->
    <div class="col-lg-12 col-md-12 m-t-sm m-b-sm">
      <a class="btn" data-toggle="collapse" href="#collapseStats" role="button" aria-expanded="false" aria-controls="collapseStats">
        Stats
        <i class="fa fa-chevron-down btn-sm expand-show"></i>
        <i class="fa fa-chevron-up btn-sm expand-hide"></i>
      </a>
      <div class="search collapse" id="collapseStats">
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Maj TF:</div>
              <input type="number" min="0" name="maj-tf-from" v-model.number="stats['majTfFrom']" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" @keydown.enter="search">
              <input type="number" min="0" name="maj-tf-to" v-model.number="stats['majTfTo']" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input " @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Maj RD:</div>
              <input type="number" v-model.number="stats['majRdFrom']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdFrom" @keydown.enter="search">
              <input type="number" v-model.number="stats['majRdTo']"  min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input pull-right" ref="rdTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Ahr DR:</div>
              <input type="number" v-model.number="stats['AHDrFrom']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdFrom" @keydown.enter="search">
              <input type="number" v-model.number="stats['AHDrTo']"  min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Ahr RD:</div>
              <input type="number" v-model.number="stats['AHRdFrom']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdFrom" @keydown.enter="search">
              <input type="number" v-model.number="stats['AHRdTo']"  min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="rdTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Moz DA:</div>
              <input type="number" v-model.number="stats['mozDaFrom']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
              <input type="number" v-model.number="stats['mozDaTo']" min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Sem KW:</div>
              <input type="number" v-model.number="stats['semKwFrom']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
              <input type="number" v-model.number="stats['semKwTo']" min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Traffic:</div>
              <input type="number" v-model.number="stats['semTrafficFrom']"  min="0" name="" placeholder="from" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" ref="daFrom" @keydown.enter="search">
              <input type="number" v-model.number="stats['semTrafficTo']" min="0" name="" placeholder="to" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input pull-right" ref="daTo" @keydown.enter="search">
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-md-3 m-t-sm">
          <div>
            <div class="input-group">
              <div class="col-lg-4 col-md-12 col-sm-4 col-xs-4 pretty-input side-input-text">Grade:</div>
              <select v-model.number="stats['gradeFrom']" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" @change="search">
                <option value="">&gt;&gt;&gt;</option>
                <option value="0">Bad</option>
                <option value="1">Poor</option>
                <option value="2">Medium</option>
                <option value="3">Good</option>
              </select>
              <select v-model.number="stats['gradeTo']" class="col-lg-4 col-md-6 col-sm-4 col-xs-4 pretty-input" @change="search">
                <option value="">&gt;&gt;&gt;</option>
                <option value="0">Bad</option>
                <option value="1">Poor</option>
                <option value="2">Medium</option>
                <option value="3">Good</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 m-t-sm">
      <div class="col-lg-4">
        <button class="btn btn-sm btn-primary" @click="search"><i class="fa fa-search"></i> Search</button>
        <button class="btn btn-sm btn-success" @click="search($event, 'csv')"><i class="fa fa-download"></i> CSV</button>
        <button class="btn btn-sm btn-success" @click="getLinkReport" v-if="user.admin"><i class="fa fa-download"></i> Link Report</button>
      </div>
    </div>
    <div class="row col-lg-12 col-md-12 m-t-md">
      Showing <b>{{ meta.count }}</b> of <b>{{ meta.resultCount }}</b> results
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Browser } from '../../../../mixins/helperMixin'
import { PBNS_SET, APPLIED_FILTER_SET } from '../../../../store/mutation-types'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      issues: [
        {label: 'No Logins', value: 'no-logins'},
        {label: 'Expiring soon', value: 'expiring-soon'},
        {label: 'No Expiry Date', value: 'no-expiry'},
        {label: 'Parked', value: 'parked'}
      ],
      statuses: [
        {label: 'Not built', id: 'not-built'},
        {label: 'Building', id: 'building'},
        {label: 'Built', id: 'built'},
        {label: 'Issue', id: 'issue'},
        {label: 'Let Expire', id: 'let-expire'}
      ],
      types: [
        {label: 'PBN', id: 'pbn'},
        {label: 'Redirect', id: 'redirect'},
        {label: 'Money Site', id: 'money'}
      ],
      quantumCheckbox: [
        {label: 'Does not matter', value: 'null'},
        {label: 'Yes', value: '1'},
        {label: 'No', value: '0'}
      ],
      filters: {},
      stats: {},
      multiFilters: {},
      categories: [],
      tags: [],
      clients: [],
      orders: [],
      meta: {
        count: 0,
        resultCount: 0,
        limit: 0,
        offset: 0
      }
    }
  },
  computed: {
    ...mapGetters({
      sites: 'getPbns',
      f: 'getFilters',
      user: 'getUser',
      languages: 'getLanguages',
      appliedFilters: 'getAppliedFilters'
    })
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    if (!this.languages.length) {
      this.$store.dispatch('loadLanguages')
    }
    if (Object.keys(this.appliedFilters).length) {
      this.filters = {...this.appliedFilters}
    }
  },
  methods: {
    search (e, type = null) {
      axios.get('/pbn/list?' + this.buildQuery(), {
        headers: {
          'Accept': type === 'csv' ? 'text/csv' : 'application/json'
        }
      })
        .then(r => {
          if (type === 'csv') {
            Browser.methods.downloadFile('Pbn-list.csv', r.data.data)
          } else {
            this.$store.commit(PBNS_SET, r.data.data)
            this.$store.commit(APPLIED_FILTER_SET, this.filters)
            this.meta = r.data.meta
          }
        })
        .catch(e => {
          this.$toastr.error(e, 'Whoopsy Daisy')
        })
    },
    getLinkReport () {
      let query = this.buildQuery()
      if (!this.filters['linkTags']) {
        this.$toastr.warning('Please select Link Tags for report (Links to)', 'No Link Tags')
        return
      }
      axios.get('/pbn/content/links/report?' + query, {
        headers: {
          'Accept': 'text/csv'
        }
      })
        .then(r => {
          Browser.methods.downloadFile('Link-report.csv', r.data.data)
        })
        .catch(e => {
          this.$toastr.error(e, 'Whoopsy Daisy')
        })
    },
    buildQuery () {
      let filters = {}
      Object.entries(this.multiFilters).forEach((data) => {
        filters[data[0]] = data[1].map(c => c.id)
      })

      let query = Object.keys(filters).map(key => `${key}=${filters[key]}`).join('&')
      query += '&' + Object.keys(this.filters).map(key => `${key}=${this.filters[key]}`).join('&')
      query += '&' + Object.keys(this.stats).map(key => `stats[${key}]=${this.stats[key]}`).join('&')
      console.log(query)
      return query
    },
    resetFilters () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/FootprintManager/Filters.vue